export const reportURL = process.env.REACT_APP_REPORT_URL;
export const apiURL = process.env.REACT_APP_API_URL;
export const httpOauthApiURL = process.env.REACT_APP_OAUTH_API_URL;
export const httpApiURL = process.env.REACT_APP_HTTP_API_URL;
export const hostURL = process.env.REACT_APP_HOST_URL;
export const karaokeUrl = process.env.REACT_APP_KARAOKE_HOST_URL;
export const distributionUrl = process.env.REACT_APP_DISTRIBUTION_URL;
